import {Component} from '@angular/core';
declare const $;

@Component({
    selector: 'app-notification-panel',
    templateUrl: './notification-panel.component.html',
    styleUrls: ['./notification-panel.component.css'],
    standalone: false
})
export class NotificationPanelComponent {
  public toggleNotificationsPanel() {
    $(".notifications_panel").toggleClass("hidden");
  }
}
